import clsx from "clsx";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

type Props = {
  type: "hotels" | "flights";
};

export const Switch = ({ type }: Props) => {
  const t = useTranslations();

  return (
    <div className="rounded-full bg-white p-2 flex gap-1 dark:bg-dark">
      <Link
        className={clsx(
          "block rounded-full text-sm font-switzer font-semibold py-1.5 px-8 transition-colors duration-200",
          type === "hotels"
            ? "bg-sleap-purple-300 text-white cursor-default"
            : "bg-sleap-gray-50 text-sleap-gray-950 hover:bg-white"
        )}
        href="/"
      >
        {t("HomePage.hotels")}
      </Link>
      <Link
        className={clsx(
          "block rounded-full text-sm font-switzer font-semibold py-1.5 px-8 transition-colors duration-200",
          type === "hotels"
            ? "bg-sleap-gray-50 text-sleap-gray-950 hover:bg-white"
            : "bg-sleap-purple-300 text-white cursor-default"
        )}
        href="/flights"
      >
        {t("HomePage.flights")}
      </Link>
    </div>
  );
};
